import { useEffect, useRef, useState } from "react";
import { Avatar } from "@/features/chat/components/avatar";
import "./handler-audition.css";
import "./handler-exchange.css";
type Candidate = {
  name: string;
  look: string;
  nolook?: string;
  onChoose: () => void;
};
export function HandlerExchange({
  candidates,
}: {
  candidates: [Candidate, Candidate];
}) {
  const [count, setCount] = useState(0);
  const bottom = useRef<HTMLDivElement>(null);
  const lines = [
    "I love a good surprise. Tell me about your people, and we’ll cook up something they’ll never see coming.",
    "Tell me what your day already looks like. I’ll find the adventures hiding right inside it.",
    "Oh, so we’re competing? Excellent.",
    "I thought that part was obvious.",
  ];
  useEffect(() => {
    if (count >= lines.length) return;
    const timer = setTimeout(
      () => setCount((value) => value + 1),
      count === 0 ? 1400 : 3200,
    );
    return () => clearTimeout(timer);
  }, [count, lines.length]);
  useEffect(() => {
    bottom.current?.scrollIntoView?.({ behavior: "smooth", block: "nearest" });
  }, [count]);
  return (
    <section
      className="audition handler-exchange"
      aria-label="Meet your handlers"
    >
      <header className="audition-simple-header">
        <h1 className="font-stencil">Choose your handler</h1>
        <p>
          Two have asked for the assignment. Hear them out, then pick your
          partner.
        </p>
      </header>
      <div className="audition-chat">
        <div className="exchange-portraits" aria-hidden="true">
          {candidates.map((candidate, index) => (
            <img
              key={candidate.name}
              data-handler={index}
              src={candidate.nolook || candidate.look}
              alt=""
            />
          ))}
        </div>
        <div className="audition-chat-scroll" role="log" aria-live="polite">
          {lines.slice(0, count).map((text, index) => (
            <div
              className="audition-chat-row"
              data-handler={index % 2}
              key={text}
            >
              <Avatar
                name={candidates[index % 2].name}
                ai
                className="exchange-avatar"
              />
              <div className="exchange-message">
                <small className="exchange-sender">
                  {candidates[index % 2].name}
                  <span>
                    {" "}
                    → {index < 2 ? "you" : candidates[(index + 1) % 2].name}
                  </span>
                </small>
                <div className="audition-chat-bubble">
                  <p>{text}</p>
                </div>
              </div>
            </div>
          ))}
          {count < lines.length && (
            <div
              className="audition-chat-row"
              data-handler={count % 2}
              role="status"
              aria-label={`${candidates[count % 2].name} is typing`}
            >
              <Avatar
                name={candidates[count % 2].name}
                ai
                className="exchange-avatar"
              />
              <div className="exchange-message">
                <small className="exchange-sender">
                  {candidates[count % 2].name}
                </small>
                <div
                  className="audition-chat-bubble exchange-typing"
                  aria-hidden="true"
                >
                  <i />
                  <i />
                  <i />
                </div>
              </div>
            </div>
          )}
          <div ref={bottom} />
        </div>
        <div className="audition-chat-choice">
          {candidates.map((candidate, index) => (
            <button
              key={candidate.name}
              data-handler={index}
              onClick={candidate.onChoose}
            >
              Choose {candidate.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
